import jwt_decode from "jwt-decode";

const IsBelgian = () => jwt_decode(localStorage.getItem('access-token'))["country_iso_code"] === "BE";

export default IsBelgian;